import actions from './actions'

const memberInfo = {
  state: {
    memberCard: {
      id: null,
      memberId: '',
      name: ''
    },
    canModifySubMember: false,
    mainContact: {},
    mySubMemberList: []
  },
  mutations: {
    setMemberInfo (state, data) {
      state.memberCard = data
      state.canModifySubMember = data.canModifySubMember
      this.commit('setMainContact', data.mainContact)
    },
    setMainContact (state, data) {
      state.mainContact = data
    },
    setMySubMemberList (state, data) {
      state.mySubMemberList = data
    }
  },
  actions
}

export default memberInfo
